import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
    Box,
    Button,
    Collapse,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import moment from "moment";
import { ModalAuditar } from "../gestionAuditoria/ModalAuditar";
import { ModalHistorialCambios } from "../gestionAuditoria/ModalHistorialCambios";
import IconEstado from "../UI/IconEstado";
import { PracticaItem } from "../gestionAuditoria/PracticaItem";
import InfoHistorialIcon from "../UI/InfoHistorialIcon";

import { AUTORIZACIONES_BANDEJAS, AUTORIZACIONES_SOLICITUDES_ESTADOS } from "../../../utils/constants";
import { getTraerSolicitudPorIdSolicitud, putCancelarSolicitud, setEstadoSolicitudes, setSolicitud } from "../../../actions/autorizaciones/Autorizaciones";
import { useDispatch, useSelector } from "react-redux";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { AUTORIZACIONES_PERMISOS } from "../../../utils/permisos";
import { AlertFinalizadoStepper } from "../../stepper/AlertFinalizadoStepper";

const useRowStyles = makeStyles({
    root: {
        "& > *": {
            borderBottom: "unset",
        },
    },
});

export const ListaSolicitudesItem = (props) => {
    const { item } = props;
    const dispatch = useDispatch();
    const classes = useRowStyles();
    const { permisos: permisosUser } = useSelector((state) => state.auth);
    const [open, setOpen] = React.useState(props.expandirPracticas);
    const [openModalAuditar, setOpenModalAuditar] = useState(false);
    const [openModalHistorialCambios, setOpenModalHistorialCambios] = useState(false);
    const [confirmarCancelar, setConfirmarCancelar] = useState(false);

    const obtenerNombreBandeja = (idBandeja) => {
        console.log(idBandeja)
        switch (idBandeja) {
            case AUTORIZACIONES_BANDEJAS.AUDITOR_MEDICO:
                return 'Auditor Médico';
            case AUTORIZACIONES_BANDEJAS.AUDITOR_TRAUMATOLOGICO:
                return 'Auditor Traumatológico';
            case AUTORIZACIONES_BANDEJAS.AUDITOR_ONCOLOGICO:
                return 'Auditor Oncológico';
            case AUTORIZACIONES_BANDEJAS.COMPRAS:
                return 'Compras';
            case AUTORIZACIONES_BANDEJAS.FISIATRIA:
                return 'Fisiatría';
            /*case AUTORIZACIONES_BANDEJAS.DIRECCION_MEDICA:
                return 'Dirección Médica';*/
            case AUTORIZACIONES_BANDEJAS.JEFATURA_AUDITORIA_MEDICA:
                return 'Jefatura Auditoría Médica';
            case AUTORIZACIONES_BANDEJAS.AUDITORIA_ADMINISTRATIVA:
                return 'Auditoría Administrativa';
            case AUTORIZACIONES_BANDEJAS.AUDITORIA_TERRENO:
                return 'Auditoría en Terreno';
            case AUTORIZACIONES_BANDEJAS.INTERNACION_PAIS:
                return 'Internación en País';
            case AUTORIZACIONES_BANDEJAS.AUDITOR_PRESUPUESTOS:
                return 'Auditor Presupuestos';
            case AUTORIZACIONES_BANDEJAS.CONTRATOS:
                return 'Contratos';
            case AUTORIZACIONES_BANDEJAS.INTERNACION_DOMICILIARIA:
                return 'Internación Domiciliaria';
            case AUTORIZACIONES_BANDEJAS.OXIGENO:
                return 'Oxigeno';
            default:
                return 'En Carga';
        }
    };

    const handleSendEliminar = (idSolicitud) => {
        dispatch(
            putCancelarSolicitud(
                idSolicitud,
                false,
                false,
                null,
                props.filtros,
                props.reiniciarBuscador,
                setConfirmarCancelar
            )
        );
    };

    console.log(item)
    return (
        <>
            {openModalAuditar && (
                <ModalAuditar
                    open={openModalAuditar}
                    closeModalHandler={() => {
                        setOpenModalAuditar(false);
                    }}
                    solicitud={item}
                    disabled={true}
                    seguimiento={true}
                //permisoIngresoInterDom={true}
                />
            )}
            {openModalHistorialCambios && (
                <ModalHistorialCambios
                    open={openModalHistorialCambios}
                    closeModalHandler={() => {
                        setOpenModalHistorialCambios(false);
                    }}
                    solicitud={item}
                    titulo={`Solicitud N° ${item.idSolicitud}`}
                />
            )}
            <AlertFinalizadoStepper
                open={confirmarCancelar}
                pregunta={"Cancelar Solicitud"}
                dialogText={`Esta seguro de cancelar la Solicitud N° ${item.idSolicitud} de ${item.afiliado?.apellido_y_nombre} del tipo ${item.tipoSolicitud.descripcionTipo}?`}
                buttonCancel={"Cancelar"}
                buttonSubmit={"Confirmar"}
                handleClose={() => setConfirmarCancelar(false)}
                handleSend={() => handleSendEliminar(item.idSolicitud)}
                filtros={props.filtros}
            />
            <TableRow className={classes.root} style={{ backgroundColor: item?.fechaBaja === null ? 'inherit' : '#e57373' }}>
                <TableCell align="center" sx={{ padding: "10px" }}>
                    <InfoHistorialIcon onClick={() => setOpenModalHistorialCambios(true)} />
                </TableCell>
                <TableCell align="right">
                    {item.urgente && (
                        <IconEstado
                            texto={"U"}
                            useColorTable={true}
                            descripcion={'Urgente'}
                            extraMarginRight={true}
                            backgroundColor={"red"}
                        />
                    )}
                    <IconEstado
                        useColorTable={true}
                        texto={item?.estadosSolicitud?.letra}
                        backgroundColor={item?.estadosSolicitud?.color}
                        descripcion={item?.estadosSolicitud?.descripcion}
                    />
                </TableCell>
                <TableCell align="center">
                    {obtenerNombreBandeja(item.idBandejaAutorizacion)}
                </TableCell>
                <TableCell align="center"> {item.fechaEnviada === null ? "" : moment(item.fechaEnviada).format("DD/MM/YYYY")} </TableCell>
                <TableCell align="left">{item.idSolicitud}</TableCell>
                <TableCell align="left">{item.tipoSolicitud.descripcionTipo}</TableCell>
                <TableCell align="left">{item.conInternacion ? 'SI' : 'NO'}</TableCell>
                <TableCell align="left">{item.diagnostico?.problema}</TableCell>
                <TableCell>
                    {item.practicas.length > 0 && (
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => {
                                if (!open)
                                    dispatch(getTraerSolicitudPorIdSolicitud(item.idSolicitud, parseInt(item.idEstadoSolicitud), false, null, setOpen(!open)));
                                else
                                    setOpen(!open)
                            }}
                        >
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    )}
                </TableCell>
                <TableCell align="left">{(item.idMotivoInternacion && item.idMotivoInternacion !== 4) ? 'SI' : 'NO'}</TableCell>
                <TableCell align="left">{item.afiliado?.apellido_y_nombre}</TableCell>
                <TableCell align="left">{item.afiliado?.carnet}</TableCell>
                <TableCell align="left">
                    {item.seccional?.descripcion_seccional}
                </TableCell>
                <TableCell align="left">
                    {item.fechaBaja ? moment(item.fechaBaja).format("DD/MM/YYYY") : ""}
                </TableCell>
                <TableCell align="left">
                    {item.fechaBaja ? item.usuarioBaja?.userName : ""}
                </TableCell>
                <TableCell align="center" sx={{ padding: "10px" }}>
                    <Button
                        style={{ fontSize: "0.8rem" }}
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setOpenModalAuditar(true);
                            dispatch(setSolicitud(item));

                            dispatch(setEstadoSolicitudes(item.idEstadoSolicitud === 4 ? 99 : item.idEstadoSolicitud))
                        }}
                    >
                        Ver
                    </Button>
                </TableCell>
                {item.fechaBaja === null 
                && validarSoloUnPermiso(permisosUser, AUTORIZACIONES_PERMISOS.DELETE_SOLICITUDES_SEGUIMIENTO)
                && (item.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.EN_CARGA ||
                    item.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE ||
                    item.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.DEVOLUCION ||
                    item.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.PENDIENTE_EVALUACION_APP
                )
                    && <TableCell align="center" sx={{ padding: "10px" }}>
                        <Button
                            style={{ fontSize: "0.8rem" }}
                            variant="contained"
                            color="primary"
                            onClick={() => setConfirmarCancelar(true)}
                        >
                            Eliminar
                        </Button>
                    </TableCell>}
            </TableRow>
            <TableRow>
                <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 100 }}
                    colSpan={11}
                >
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="h6" gutterBottom component="div">
                                Practicas
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Estado Práctica</TableCell>
                                        <TableCell>Práctica</TableCell>
                                        <TableCell align="right">Cantidad</TableCell>
                                        <TableCell align="center">SURGE</TableCell>
                                        <TableCell>Materiales</TableCell>
                                        <TableCell>Institucion</TableCell>
                                        {(item.conInternacion || item.idPrestacion) &&
                                            <TableCell>Profesional</TableCell>
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {item.practicas.map((practica) => (
                                        <PracticaItem
                                            key={practica?.idCodNom?.toString()}
                                            conInternacion={item.conInternacion}
                                            idPrestacion={item.idPrestacion}
                                            item={practica}
                                            materialCotizacion={item.cotizaciones}
                                            estadoSolicitud={item?.idEstadoSolicitud}
                                        />
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>

            </TableRow>
        </>
    )
}
